import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import { FlagsList } from 'ui';
import { profilePicturesPath } from 'shared/constants/picturesPath';

const useStyles = makeStyles(theme => ({
  actions: {
    marginLeft: 'auto',
  },
  profileInfo: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
  },
  profilePicture: {
    width: 200,
    height: 200,
    borderRadius: theme.shape.borderRadius,
  },
}));

const ProfileInfo = ({ imageUrl, name, title, subtitle, languages, actions }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.profileInfo}>
      <Grid container spacing={2}>
        <Grid item>
          <img className={classes.profilePicture} src={imageUrl} alt="Avatar" />
        </Grid>
        <Grid item>
          <Typography variant="h5">{name}</Typography>
          {title && (
            <Typography variant="subtitle1" color="textSecondary">
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="subtitle2" color="textSecondary">
              {subtitle}
            </Typography>
          )}
          {languages && <FlagsList countryCodes={languages} />}
        </Grid>
        {actions && (
          <Grid item className={classes.actions}>
            {actions}
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

ProfileInfo.defaultProps = {
  imageUrl: profilePicturesPath,
  title: null,
  subtitle: null,
  actions: null,
  languages: null,
};

ProfileInfo.propTypes = {
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  actions: PropTypes.node,
  languages: PropTypes.arrayOf(PropTypes.string.isRequired),
};

export default ProfileInfo;
